export enum EProjects {
  CHECKIN = 'checkin',
  INBOX = 'inbox',
  PAYMENTS = 'payments',
  CHECKOUT = 'checkout'
}
